import { axiosInstance } from '../../api';
const BASE_PATH = '/company_user';

//Get Assigned Tasks API Call
export let getAssignedTasks = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_assigned_tasks');
        return value;
    } catch (error) {
        return error
    }
}